var React = require('react');

function LeftArrowCarrusel (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.70697 1.15192C8.51944 0.964446 8.26513 0.859131 7.99997 0.859131C7.73481 0.859131 7.4805 0.964446 7.29297 1.15192L0.292969 8.15192C0.105497 8.33945 0.000183105 8.59375 0.000183105 8.85892C0.000183105 9.12408 0.105497 9.37839 0.292969 9.56592L7.29297 16.5659C7.48157 16.7481 7.73417 16.8489 7.99637 16.8466C8.25857 16.8443 8.50938 16.7391 8.69479 16.5537C8.8802 16.3683 8.98536 16.1175 8.98764 15.8553C8.98992 15.5931 8.88913 15.3405 8.70697 15.1519L2.41397 8.85892L8.70697 2.56592C8.89444 2.37839 8.99976 2.12408 8.99976 1.85892C8.99976 1.59375 8.89444 1.33945 8.70697 1.15192Z"}));
}

LeftArrowCarrusel.defaultProps = {"width":"9","height":"17","viewBox":"0 0 9 17","fill":"none"};

module.exports = LeftArrowCarrusel;

LeftArrowCarrusel.default = LeftArrowCarrusel;
